var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-card",
        { staticClass: "rounded-card mt-20" },
        [
          _c(
            "v-container",
            { attrs: { "grid-list-md": "" } },
            [
              _c(
                "v-form",
                { staticClass: "col-md-12" },
                [
                  _c("StepTitle", [_vm._v("Planes Mantenimiento")]),
                  _c("v-divider"),
                  _c(
                    "FormFieldsContainer",
                    [
                      _c(
                        "v-flex",
                        { attrs: { md6: "" } },
                        [
                          _c("BuscadorOperacionCrud", {
                            attrs: {
                              filter:
                                _vm.gridApi &&
                                _vm.gridApi.setQuickFilter.bind(_vm.gridApi)
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { attrs: { align: "left" } },
                    [
                      _c(
                        "v-flex",
                        [
                          _c("MantenedorGrid", {
                            attrs: {
                              "grid-options": _vm.gridOptionsPlanesMantencion
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }